const STORED_FORMAT = "HH:mm";

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, index) => index);
export const MINUTE_OPTIONS = Array.from({ length: 60 }, (_, index) => index);

export function padTimeUnit(value) {
  return String(value).padStart(2, "0");
}

export function parseStoredTime(value) {
  if (!value) {
    return { hour: null, minute: null, isValid: false };
  }

  const trimmed = String(value).trim();
  const match = trimmed.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) {
    return { hour: null, minute: null, isValid: false };
  }

  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
    return { hour: null, minute: null, isValid: false };
  }

  return { hour, minute, isValid: true };
}

export function formatStoredTime(hour, minute) {
  if (hour == null || minute == null) {
    return "";
  }
  return `${padTimeUnit(hour)}:${padTimeUnit(minute)}`;
}

export function formatStoredTimeValue(value) {
  const parsed = parseStoredTime(value);
  if (!parsed.isValid) {
    return "";
  }
  return formatStoredTime(parsed.hour, parsed.minute);
}

export function getCurrentTime() {
  const now = new Date();
  return {
    hour: now.getHours(),
    minute: now.getMinutes(),
  };
}

export { STORED_FORMAT };
